import axios from 'axios';
import Constants from '../common/constants';
import grantPermission from '../common/helpers/grantPermission';
import { Cookies } from 'react-cookie';
import authAxios from '../common/authAxios';

const cookies = new Cookies(); // Создаём экземпляр Cookies

class AuthService {
	static async login(data) {
		try {
			axios.defaults.withCredentials = true;
			const response = await axios.post(
				`${Constants.API_BASE_URL}/auth/sign-in`,
				data
			);
			console.log('Login successful', response);

			this.setCredentials(response);
			return response;
		} catch (error) {
			return this.handleError(error);
		}
	}

	static async registration(data) {
		try {
			const formData = new FormData();
			if (data.avatar) formData.append('avatar', data.avatar);
			formData.append(
				'data',
				new Blob([JSON.stringify(data)], { type: 'application/json' })
			);

			const response = await axios.post(
				`${Constants.API_BASE_URL}/auth/sign-up`,
				formData,
				{ headers: { 'Content-Type': 'multipart/form-data' } }
			);
			return response;
		} catch (error) {
			return this.handleError(error);
		}
	}

	static async updateUserInfo(data) {
		try {
			const formData = new FormData();
			if (data.avatar) formData.append('avatar', data.avatar);
			formData.append(
				'data',
				new Blob([JSON.stringify(data)], { type: 'application/json' })
			);
			console.log(data.avatar);
			
			console.log(data);
			const response = await authAxios.post(
				`${Constants.API_BASE_URL}/auth/update-info`,
				formData,
				{ headers: { 'Content-Type': 'multipart/form-data' } }
			);
			return response;
		} catch (error) {
			return this.handleError(error);
		}
	}

	static handleError(error) {
		if (!error.response) return Promise.reject('Internal server error');
		const { status, data } = error.response;

		switch (status) {
			case 400:
				const errorMessages =
					typeof data.error === 'object'
						? Object.values(data.error).join(', ')
						: data.error || 'Validation error occurred';
				return Promise.reject(errorMessages);
			case 409:
				return Promise.reject(data.message);
			case 500:
				return Promise.reject('Internal server error');
			case 401:
			case 404:
				return Promise.reject(data.message);
			default:
				return Promise.reject('An error has occurred');
		}
	}

	static validateEmail(email) {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return regex.test(email);
	}

	static async checkPermissionToPage(roles) {
		if (this.isLoggedIn()) {
			if (!roles.some(role => grantPermission(role))) {
				window.location = '/access-denied';
			}
		} else {
			window.location = '/login';
		}
	}
	

	static setCredentials(response) {
		const userData = JSON.stringify(response.data);
		cookies.set('user', userData, {
			path: '/',
			secure: true,
			sameSite: 'strict'
		});
	}

	static async resetPassword(data) {
		return axios.post(
			`${Constants.API_BASE_URL}/account-info/reset-password-send-email`,
			data
		);
	}

	static async sendVerificationEmail(email) {
		return axios.post(
			`${Constants.API_BASE_URL}/auth/send-verification-email`,
			{ email }
		);
	}

	static async logout() {
		try {
			await axios.post(`${Constants.API_BASE_URL}/auth/sign-out`);
			cookies.remove('user', { path: '/' });
			cookies.remove('SESSION');

			if (!cookies.get('user') && !cookies.get('SESSION')) {
				window.location = '/login';
			} else {
				console.error('Не удалось удалить cookies');
			}
		} catch (error) {
			console.error('Ошибка при запросе выхода:', error);
		}
	}

	static isLoggedIn() {
		const user = cookies.get('user');
		if (user) {
			return true;
		}
		return !!user;
	}

	static isLoggedInSync() {
		return !!cookies.get('user');
	}

	static syncLogoutEvent() {
		window.addEventListener('storage', event => {
			if (event.key === 'logout-event') {
				// Если сработало событие выхода, перезагружаем
				window.location.reload();
			}
		});
	}

	static async getUserInfo() {
		const response = await authAxios.get(
			`${Constants.API_BASE_URL}/auth/user-info`
		);
		this.setCredentials(response);
		return response;
	}

	static getCurrentUserJson() {
		const user = cookies.get('user');
		console.log(user);
		return user ? JSON.parse(user) : null;
	}

	static getCurrentUser() {
		const user = cookies.get('user');
		if (!user) return null;
		return user;
	}
}

AuthService.syncLogoutEvent();
export default AuthService;
